<template>
	<el-dialog :title="title" :close-on-click-modal="false" :visible.sync="subVisible" width="922px" ref="dialog">
		<el-row>
			<div class="tiv">描述</div>
		</el-row>
		<el-row style="margin-top:10px;margin-bottom:10px">
			<el-input type="textarea" rows="9" v-model="dataForm.fileName" placeholder="请填写"></el-input>
		</el-row>
		<el-row>
			<div class="tiv">
				照片上传
			</div>
		</el-row>
		<el-row style="margin-left:114px;margin-top:10px">
			<el-col :span="24">
				<el-upload ref="uploadSituation" class="upload-demo" action="action" style="margin-left: -115px;"
					:http-request="uploadSituation" multiple drag :show-file-list=false :auto-upload="true"
					accept="image/jpeg,image/png,image/jpg" :before-upload="beforeUploadSituation">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				</el-upload>
			</el-col>
		</el-row>
		<el-row style="margin-top:10px">
			<el-col :span="24">
				<el-table v-if="dataForm.photoList != undefined && dataForm.photoList.length > 0" border
					:data="dataForm.photoList" style="width: 100%;">
					<el-table-column type="index" label="No." width="60" align="center">
					</el-table-column>
					<el-table-column label="图片" width="180" align="center">
						<template slot-scope="scope">
							<el-image style="height: 100px" :src="scope.row.compressedPathUri" fit='contain'></el-image>
						</template>
					</el-table-column>
					<el-table-column label="描述" width="500px" align="center">
						<template slot-scope="scope">
							<el-input type="textarea" rows="2" v-model="dataForm.photoList[scope.$index].fileName"
								placeholder="请填写"></el-input>
						</template>
					</el-table-column>
					<el-table-column label=" " width="120" align="center">
						<template slot-scope="scope">
							<el-button type="text" @click="delPhoto(scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row class="formBtnGroup">
			<el-col :span="24">
				<el-button class="btn" type="primary" size="small" @click="dataSubmit()">保存</el-button>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
import { initDialogDrag } from '@/utils/dialogDrag.js'
export default {
	name: "add-or-update-meeting",
	data() {
		return {
			subVisible: true,
			dataForm: {
				recNo: '',
				dataKind: '',
				monthlyRecNo: '',
				dataType: '',
				sourceId: '',
				sourceType: 0,
				sort: 0,
				fileName: '',
				filePath: '',
				photoList: [],
				updUserName: '',
			},
			recNo: '',
			title: '',
			dataType: ''
		};
	},
	methods: {
		init(monthlyRecNo, recNo, sort, dataType, progressKindName) {
			// 标题
			if (dataType === '000001') {
				if (!recNo) {
					this.title = '新增计划完成'
				} else {
					this.title = '修改计划完成'
				}
			} else if (dataType === '000002') {
				if (!recNo) {
					this.title = '新增实际完成'
				} else {
					this.title = '修改实际完成'
				}
			} else if (dataType === '000003') {
				if (!recNo) {
					this.title = '新增原因分析'
				} else {
					this.title = '修改原因分析'
				}
			} else if (dataType === '000401' || dataType == '000402') {
				if (!recNo) {
					this.title = '新增专题报告/会议纪要'
				} else {
					this.title = '修改专题报告/会议纪要'
				}
			} else if (dataType === '000005') {
				if (!recNo) {
					this.title = '新增质量签证'
				} else {
					this.title = '修改质量签证'
				}
			} else if (dataType === '000601' || dataType == '000602') {
				if (!recNo) {
					this.title = '新增向建造单位发出的通知、指示'
				} else {
					this.title = '修改向建造单位发出的通知、指示'
				}
			} else if (dataType === '000007') {
				if (!recNo) {
					this.title = '新增建造单位提出的各种报告'
				} else {
					this.title = '修改建造单位提出的各种报告'
				}
			} else if (dataType === '000008') {
				if (!recNo) {
					this.title = '新增付款签证'
				} else {
					this.title = '修改付款签证'
				}
			} else if (dataType === '050100') {
				if (!recNo) {
					this.title = '新增停止点检查情况'
				} else {
					this.title = '修改停止点检查情况'
				}
			} else if (dataType === '050200') {
				if (!recNo) {
					this.title = '新增巡检情况'
				} else {
					this.title = '修改巡检情况'
				}
			} else if (dataType === '050300') {
				if (!recNo) {
					this.title = '新增监理工作联系单和通知单（不一致项报告）处理及跟踪情况'
				} else {
					this.title = '修改监理工作联系单和通知单（不一致项报告）处理及跟踪情况'
				}
			} else if (dataType === '050400') {
				if (!recNo) {
					this.title = '新增签收及审查文件情况'
				} else {
					this.title = '修改签收及审查文件情况'
				}
			} else if (dataType === '050500') {
				if (!recNo) {
					this.title = '新增会议及会谈情况'
				} else {
					this.title = '修改会议及会谈情况'
				}
			} else if (dataType === '111111') {
				if (!recNo) {
					this.title = '新增本月监理工作小结'
				} else {
					this.title = '修改本月监理工作小结'
				}
			} else if (dataType === '222222') {
				if (!recNo) {
					this.title = '新增下月监理工作安排'
				} else {
					this.title = '修改下月监理工作安排'
				}
			} else {
				if (!recNo) {
					this.title = '新增' + progressKindName
				} else {
					this.title = '修改' + progressKindName
				}
			}
			this.dataType = dataType

			this.dataForm = {
				recNo: '',
				monthlyRecNo: monthlyRecNo,
				dataType: this.dataType,
				sourceId: '',
				sourceType: '',
				dataKind: '1',
				sort: sort,
				fileName: '',
				filePath: '',
				photoList: [],
				updUserName: $common.getItem("userName"),
			}
			this.dataForm.recNo = recNo;
			this.$nextTick(() => {
				this.subVisible = true;
				initDialogDrag(this.$refs.dialog.$el);
			})
			if (recNo) {
				this.getMonthlyFileDetail();
			}
		},
		beforeUploadSituation(file) {
			const isValidType = file.type === 'image/jpeg' ||
				file.type === 'image/png' ||
				file.type === 'image/jpg'

			if (!isValidType) {
				this.$message.error('只能上传 JPG/PNG 格式的图片！')
				return false
			}
			return true
		},

		getMonthlyFileDetail() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectmonthlyreportfile/getMonthlyFileDetail/" + this.dataForm.recNo,
				method: 'get',
				params: this.$http.adornParams({})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm = data.body
				}
			})

		},
		uploadSituation(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadSituation.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/89/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode === 200) {
					this.dataForm.photoList.push({
						filePath: res.body.fileSavePath,
						fileUri: res.body.fileUri,
						compressedPath: res.body.compressedPath,
						compressedPathUri: res.body.fileUri,
						fileName: this.extractFileName(res.body.fileName),
						dataType: this.dataType,
						dataKind: '1',
						recNo: '',
						sourceId: '',
						sourceType: '',
						subcategory: this.dataForm.recNo,
						updUserName: $common.getItem("userName"),
					});
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		extractFileName(fileName) {
			let index = fileName.lastIndexOf(".");
			return fileName.substr(0, index)
		},
		delPhoto(index) {
			this.dataForm.photoList.splice(index, 1);
		},
		dataSubmit() {
			let _url = "/business/projectmonthlyreportfile/saveReportFile";
			if (this.dataForm.recNo && this.dataForm.recNo != 0) {
				_url = "/business/projectmonthlyreportfile/updateReportFile";
			}
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData(this.dataForm)
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.subVisible = false;
							this.$emit("refreshDataList");
						}
					});
				}
			});
		},
	}
};
</script>

<style scoped="scoped">
.tiv {
	width: 135px !important;
	background-color: #E1F1FF;
	color: #00428E !important;
	font-weight: bold !important;
	padding: 10px !important;
	text-align: center;
	border: 1px solid #dadada;
}

.upload-demo /deep/ .el-upload-dragger {
	width: 468%;
	height: 100px;
}

.upload-demo /deep/ .el-upload-dragger .el-icon-upload {
	font-size: 40px;
	margin-top: 15px;
	line-height: 26px;
}

.upload-demo /deep/ .el-upload-dragger .el-upload__text {
	line-height: 8px;
}
</style>
